import type { FormikTouched } from 'formik';

import type { CodeError } from 'app/widgets/CodeConfirmation/index';

export type CodeFormValue = {
  code: string;
};

export type CodeConfirmData = {
  requisite: string;
  attemptsLeft: number;
  attemptsTotal: number;
  resendDate: string;
  serverTime: string;
};

export type RequestBody = {
  type?: string;
  phoneNumber?: string;
  email?: string;
  code?: string;
  token?: string;
  sessionToken?: string;
  phoneToken?: string;
};

export type ResendInfo = {
  dataGaEvent?: string;
  resendDate: string | number | Date;
  serverTime: string;
  onChange: () => void;
  handler: () => void;
};

export const enum DataGaEventPrefix {
  PASSWORD_RESET = 'passwordReset',
  SIGN_IN = 'signIn',
}

export type ContentData = {
  title: string;
  value: string;
  error: CodeError | null;
  onChange: (event: string) => void;
  onFocus: () => void;
  disabled: boolean;
  codeResendInfo: Omit<ResendInfo, 'dataGaEvent'>;
  changeVerifyData: () => void;
  changeValue: string;
  prompt: string;
  touched?: FormikTouched<unknown>;
};
